import { ShiftInfo } from "@dexteel/mesf-core";
import { createSlice } from "@reduxjs/toolkit";
import { ProcessByShift } from "../models/ProcessByShift";

const EAFProcessesInitialState: {
	isLoadingPage: boolean;
	isLoadingBackground: boolean;
	isLoadingGrid: boolean;
	errorMessage: string;
	notificationMessage: string;

	shiftId: number | null | false;
	shiftInfo: ShiftInfo;
	processes: ProcessByShift[];
	selectedProcess: ProcessByShift | null;
	anchorPoint: any;
} = {
	isLoadingPage: false,
	isLoadingBackground: false,
	isLoadingGrid: false,
	shiftInfo: {
		CurrentShiftId: 0,
		CurrentProductionDate: new Date(),
		CurrentProductionShift: 0,
		CurrentShift: "",
		CurrentCrew: "",
		CurrentStart: new Date(),
		CurrentEnd: new Date(),
		PreviousShiftId: 0,
		PreviousProductionDate: new Date(),
		PreviousProductionShift: 0,
		PreviousShift: "",
		PreviousCrew: "",
		PreviousStart: new Date(),
		PreviousEnd: new Date(),
		NextShiftId: 0,
		NextProductionDate: new Date(),
		NextProductionShift: 0,
		NextShift: "",
		NextCrew: "",
		NextStart: new Date(),
		NextEnd: new Date(),
		LastProductionDate: new Date(),
		LastProductionShift: 0,
		LastShift: "",
		LastShiftId: 0,
		LastCrew: "",
		LastStart: new Date(),
		LastEnd: new Date(),
	},
	processes: [],
	selectedProcess: null,
	errorMessage: "",
	notificationMessage: "",
	shiftId: false,
	anchorPoint: {
		x: 0,
		y: 0,
	},
};

export const EAFProcessesReducer = createSlice({
	name: "__",
	initialState: EAFProcessesInitialState,
	reducers: {
		setIsLoadingPage(state, { payload }) {
			state.isLoadingPage = payload;
		},
		setIsLoadingBackground(state, { payload }) {
			state.isLoadingBackground = payload;
		},
		setIsLoadingGrid(state, { payload }) {
			state.isLoadingGrid = payload;
		},
		setShiftInfo(state, { payload }) {
			state.shiftInfo = payload;
		},
		setProcesses(state, { payload }) {
			state.processes = payload;
		},
		setSelectedProcess(state, { payload }) {
			state.selectedProcess = payload;
		},
		setErrorMessage(state, { payload }) {
			state.errorMessage = payload;
		},
		setNotificationMessage(state, { payload }) {
			state.notificationMessage = payload;
		},
		setShiftId(state, { payload }) {
			state.shiftId = payload;
		},
		setAnchorPointX(state, { payload }) {
			state.anchorPoint.x = payload;
		},
		setAnchorPointY(state, { payload }) {
			state.anchorPoint.y = payload;
		},
	},
});
